import service from "@/api/service";
import { GetResponse } from "@/api/role-shop/response";

/**
 * 権限ロール設定済店舗取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get() {
  const response = await service.post("/get-role-shop");
  return response.data as GetResponse;
}
